import React from 'react';

const OrderStatusBadge = ({ orderStatus }) => {
  const getOrderStatusColor = (orderStatus) => {
    const statusColorMap = {
      "Очікує на обробку": "#2F80ED", // NEW - Синій
      "Підтверджено, очікує на пакування": "#56CCF2", // WAITING_FOR_PACKAGING - Світло-синій
      "Упаковано, очікує на відправлення": "#2D9CDB", // WAITING_FOR_SENDING - Фіолетовий
      "Відправлено": "#27AE60", // SENT - Зелений
      "Передзамовлення": "#27AE60", // PREORDER - Зелений (як на сторінці товару, в кошику та підтвердженні)
      "Відкладено": "#F2C94C", // HOLD - Жовтий
      "Відмінено": "#EB5757", // CANCELLED - Червоний
      "Повернено": "#EB5757", // RETURNED — як скасування
    };
    return statusColorMap[orderStatus] || "#6C757D"; // Дефолтний сірий
  };

  const getOrderStatusIcon = (orderStatus) => {
    const statusIconMap = {
      "Очікує на обробку": "bi-clock",
      "Підтверджено, очікує на пакування": "bi-check-circle",
      "Упаковано, очікує на відправлення": "bi-box-seam",
      "Відправлено": "bi-truck",
      "Передзамовлення": "bi-calendar-check",
      "Відкладено": "bi-pause-circle",
      "Відмінено": "bi-x-circle",
      "Повернено": "bi-arrow-counterclockwise",
    };
    return statusIconMap[orderStatus] || "bi-circle";
  };

  if (!orderStatus) return null;

  return (
    <strong style={{ color: getOrderStatusColor(orderStatus), fontSize: '0.95rem' }}>
      <i className={`bi ${getOrderStatusIcon(orderStatus)} mr-1`}></i>
      {orderStatus}
    </strong>
  );
};

export default OrderStatusBadge;